
<div class="card">
    <p-carousel>
        <ng-template let-product pTemplate="item">
            <div class="">
                <img src="../../assets/images/banner.svg" alt="banner.svg">
           </div>
        </ng-template>
        <ng-template let-product pTemplate="item">
            <div class="">
                <img src="../../assets/images/banner.svg" alt="banner.svg">
           </div>
        </ng-template>
    </p-carousel>
</div>
